import React from 'react';
import { useTranslation } from 'react-i18next';
import { GetStartedCard } from './GetStartedCard';
import { getStartedCards } from './get-started-config';

export const GetStartedSection: React.FC = () => {
  const { t } = useTranslation();

  return (
    <section className="w-full mt-10">
      <header className="mb-6">
        <h2 className="text-xl font-bold text-[#004232] dark:text-white">
          {t('getStarted.title')}
        </h2>
      </header>
      
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {getStartedCards.map((card) => (
          <GetStartedCard key={card.id} {...card} />
        ))}
      </div>
    </section>
  );
};

